const beam = {
  background: {
    primary: '#090c10',
    /** @depracated Use COLORS_FLAT.n200  ~~n200 */
    card: '#e9edf1',
    whiteButton: '#edeff4',
    field: '#f7f7f7',
    icon: '#C4C4C4',
    tag: '#edeff4',
    /** @depracated Use COLORS_FLAT.b50 (best approximation of this color) */
    hover: '#F6F8FF',
  },
  color: {
    pureWhite: '#FFFFFF',
    pureBlack: '#000000',
    primaryBlue: '#1371fe',
  },
  status: {
    online: '#249D0E',
    offline: '#DFAE00',
    decommissioned: '#838A91',
  },
  lines: {
    white: '#e5eaef',
  },
  neutral: {
    n600: '#8F95B2',
    n800: '#474D66',
  },
  font: {
    primary: '#1a1b1c',
    black: '#161a30',
    disabled: '#838A91',
    missing: '#686D73',
    header: '#1f1f1f',
    label: '#838a91',
    link: '#1371FE',
    error: '#EA1212',
    tableHeader: '#758ca3',
    neutral: '#474D66',
  },
  placeholder: {
    primary: '#787878',
  },

  shimmer: {
    primary: '#090c10',
    secondary: '#030506',
  },

  border: {
    primary: '#d0dae3',
    secondary: '#30363d',
    back: '#E9EDF1',
    error: '#ea1212',
  },
};

export { beam };
